import { useState } from 'react'

import { useQuery } from 'providers/tanstack-query/useQuery'
import { fromDTO, sortToDTO } from './api/mapper'
import { GET_DOMAIN_PREBID_MODULES } from './api/query'
import { Data, DomainPrebidModuleSliceDTO, Variables } from './api/types'
import { DomainPrebidModuleSlice, UseGetDomainModules, UseGetDomainModulesProps } from './types'

export const useGetDomainPrebidModules = ({
  domainId,
  moduleType,
  sort,
}: UseGetDomainModulesProps): UseGetDomainModules => {
  const [modules, setModules] = useState<DomainPrebidModuleSlice[]>([])

  const { isLoading: loading } = useQuery<Variables, Data>({
    onCompleted: async data => {
      const {
        domainPrebidModules: { nodes: modules },
      } = data

      if (modules) {
        setModules(
          modules.map(
            (module: DomainPrebidModuleSliceDTO): DomainPrebidModuleSlice => fromDTO(module),
          ),
        )
      }
    },
    query: GET_DOMAIN_PREBID_MODULES,

    variables: {
      domainId,
      moduleType,
      sort: sortToDTO(sort),
    },
  })

  return {
    loading,
    modules,
  }
}
